import {createGlobalStyle} from 'styled-components'; // necessário instalar extensão "npm install styled-components"

export default createGlobalStyle`
 *{
   margin: 0;
   padding: 0;
   outline:0;
   box-sizing: border-box;
 }

 html, body, #root{
   min-height: 100%;
 }

 body{
   background: #222;
   font-size: 14px;
   -webkit-font-smoothing: antialiased !important;
 }


`;